var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-account';
                    var viewUrl = 'sprite.svg#view-icon-account';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 20 20',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };